<template>
  <v-dialog v-model="intDialogVisible" max-width="1000px" class="addValueModal editStartupModal addComment" persistent>
    <v-card v-if="what == 'needhelp'">
      <v-card-title class="withStepper">
        Contact us
      </v-card-title>
      <div class="v-card-content">
        <div class="oneField">
          <span class="fieldTitle">Your name<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="contactus_name" placeholder="Your name" v-model="contactus.name"/>
          </div>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Email<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="contactus_email" placeholder="Your email" v-model="contactus.email"/>
          </div>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Company name<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="contactus_companyname" placeholder="Your company" v-model="contactus.company_name"/>
          </div>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Topic<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="contactus.topic" placeholder="Select a topic"  chips closable-chips  :items="['Technical support','Taxonomy','General support']" item-color="#FFF" ></v-autocomplete>
          </div>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Message<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <textarea ref="contactusmsg" placeholder="" @input="resize('contactusmsg')" name="name" rows="4" cols="30" v-model="contactus.message"></textarea>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Explain your question or issue in few words. This will help us assist you more efficiently.</span>
           </span>
        </div>
      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="sendMsg">
          Send
        </button>

      </div>
    </v-card>
    <v-card v-if="what == 'global'">
      <div class=""  id="stepperScrollCard">  </div>
      <v-card-title class="withStepper" ref="stepperTitle" id="stepperTitle">
          <span v-if="step == 1">Summary</span>
          <span v-else-if="step == 2">Solution</span>
          <span v-else-if="step == 3">Customers value</span>
          <span v-else-if="step == 4">Resources</span>
          <span v-else-if="step == 5">Business Traction</span>

          <span v-else-if="step == 6">Contacts</span>

          <span v-else>Complete your profile</span>
          <div class="stepper">
            STEP {{step}}/6
          </div>
      </v-card-title>
      <div ref="multiStepContent" id="multiStepContent">


      <div class="v-card-content" v-if="step == 1" :id="'step-'+step">

        <div class="oneField">
          <span class="fieldTitle">Company name<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="startupname" placeholder="Your company" v-model="startup.name"/>
          </div>
        </div>



        <div class="oneField">
          <span class="fieldTitle mb0">Banner</span>
          <div class="info_startup_2" >
            <div class="col-12 startup_banner " >
                 <img :src="this.apiUrl+'/get_image/'+startup_image+'?token='+$store.state.innotoken" alt="" class="" v-if="startup_image">
                 <div class="fallbackBanner" v-else>
                   <img :src="require('@/assets/defban.jpg')" alt=""/>

                 </div>
                 <div class="changeImage" v-if=" startup._id">
                    <button type="button" name="button" @click='$refs.bannerUp.focus();$refs.bannerUp.click();'>
                        <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>
                    </button>
                    <input type="file" ref="bannerUp" name="bannerUp" id="bannerUp" @change="selectBanner" accept="image/*"/>
                   </div>
                   <div class="row uploadProceedBanner" v-if="uploadProceedBanner">
                     <div class="col-12 text-center uploadProcess">
                         <span class="progressText">Upload in progress. Please wait a moment.</span>
                       <v-progress-linear
                         v-model="progress"
                         color="blue-grey"
                         height="25"
                       >
                     </v-progress-linear>

                     </div>

                   </div>
            </div>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Make your innovation visible to potential partners - Recommended size : 1600x500px</span>
           </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle mb0">Logo</span>

          <div class="info_startup_2" >
            <div class="startup_logo">
                <div class="" v-if="startup_logo">
                  <img :src="this.apiUrl+'/get_image/'+startup_logo+'?token='+$store.state.innotoken" alt="" class="" v-if="startup_logo">
                </div>
                <div class="fallbackLogo" v-else>
                  <img :src="require('@/assets/logodef.jpg')" alt=""/>

                </div>
                <div class="changeImageLogo" v-if=" startup._id">
                   <button type="button" name="button" @click='$refs.logoUp.focus();$refs.logoUp.click();'>
                       <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>
                   </button>
                   <input type="file" ref="logoUp" name="logoUp" id="logoUp" @change="selectLogo" accept="image/*"/>
                  </div>
                  <div class="row uploadProceedBanner" v-if="uploadProceedLogo">
                    <div class="col-12 text-center uploadProcess">
                        <span class="progressText">Upload in progress. Please wait a moment.</span>
                      <v-progress-linear
                        v-model="progress"
                        color="blue-grey"
                        height="25"
                      >
                    </v-progress-linear>

                    </div>

                  </div>
            </div>
          </div>

        </div>


        <div class="oneField">
          <span class="fieldTitle">Foundation year<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="number" min="1900" class="info_value" name="name" placeholder="Foundation year" v-model="startup.company_founded_year"/>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Website URL<sup class="required">*</sup><br/>
          <small>Your link must be secure include https://</small></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="name" @input="toLowercase" v-model="startup.website" placeholder="Ex: https://innopear.ch"/>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Pitch your company<sup class="required">*</sup></span>
          <div class="info_startup_2">
            <textarea ref="value_proposition" placeholder="Pitch your company" @input="resize('value_proposition')" name="name" rows="4" cols="30" v-model="startup.value_proposition"></textarea>
            <span class="lengthIndicator" v-if="startup.value_proposition">
              <span v-if="startup.value_proposition.length <= 700">Caracters: {{startup.value_proposition.length}} / 700</span>
              <strong v-else class="tred">Character limit exceeded.<br/>Maximum number of characters exceeded. You can continue to edit but will have to shorten the text before submission.</strong>
            </span>

          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Provide a short overview of your company</span>
           </span>

        </div>

        <div class="oneField">
          <span class="fieldTitle">Tell us more about your solution<sup class="required">*</sup></span>
          <div class="info_startup_2">
            <textarea ref="solution" placeholder="What solution do you provide?" @input="resize('solution')" name="name" rows="4" cols="30" v-model="startup.solution"></textarea>
            <span class="lengthIndicator" v-if="startup.solution">
              <span v-if="startup.solution.length <= 700">Caracters: {{startup.solution.length}} / 700</span>
              <strong v-else class="tred">Character limit exceeded.<br/>Maximum number of characters exceeded. You can continue to edit but will have to shorten the text before submission.</strong>
            </span>
        </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Where are you based?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <treeselect v-model="startup.location" :multiple="true" :options="dict.location" placehoder="Where are you based?"/>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Region / Country</span>
           </span>

        </div>

        <div class="oneField"> <!-- Applicaton domain -->
          <span class="fieldTitle">What are the main application domains of your solution?<sup class="required">*</sup></span>
          <div class="info_startup_2">
            <v-autocomplete v-model="startup.application_area" chips closable-chips  :items="dict.application_areas" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>

          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Select industry or field where your innovation could be utilized</span>
           </span>

        </div>

        <div class="oneField">
          <span class="fieldTitle">Who are the founders?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <div class="listOfFounders" v-if="isThereFounders(startup.founders)">
              <table class="table">
                <tbody>
                  <tr class="" v-for='(f,i) in startup.founders' :key="i">
                    <td>   {{f.name}} <span v-if="f.position">- {{f.position}}</span></td>
                    <td>   {{f.email}}</td>
                    <td class="text-right">
                      <a v-if="founderLink(f.linkedin_profile)" :href="founderLink(f.linkedin_profile)" target="_blank" class="picto_link_linkedin"><v-icon icon="mdi:mdi-linkedin" style="font-size: 20px;"/></a>
                      <button @click="removeFounder(f,i)" class="trashFounder"><v-icon icon="mdi:mdi-trash-can-outline" style="font-size: 18px;"/></button>

                  </td>
                  </tr>
                </tbody>

              </table>


            </div>
            <div class="subfields">
              <div class="oneField">
                <span class="fieldSubTitle">Full name<sup class="required">*</sup></span>
                <input type="text" class="info_value" name="name" v-model="founder.name" placeholder="Full name"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.founder.name.$errors.length > 0">
                    <div  v-for="(error, index) of v$.founder.name.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Role<sup class="required">*</sup></span>
                <input type="text" class="info_value" name="name" v-model="founder.position" placeholder="Role"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.founder.position.$errors.length > 0">
                    <div  v-for="(error, index) of v$.founder.position.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Email</span>
                <input type="text" class="info_value" name="name"  v-model="founder.email" placeholder="Email"/>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Linkedin Profile</span>
                <input type="text" class="info_value" name="name"  v-model="founder.linkedin_profile" placeholder="Linkedin profile"/>
              </div>
              <div class="">
                <button type="button" class="addValue" @click="addFounder()" name="button">Validate thefounder</button>
              </div>
            </div>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Do you have a female co-founder?<sup class="required">*</sup></span>
          <div class="info_startup_2 dblock" >
            <label class="rocker mt20 ml20">
        <input type="checkbox" v-model="startup.woman_cofounder" >
        <span class="switch-left">YES</span>
        <span class="switch-right">NO</span>
      </label>
          </div>
        </div>




      </div>

      <div class="v-card-content" v-if="step == 2" :id="'step-'+step">
        <div class="oneField">
          <span class="fieldTitle">What is your innovation's development stage?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.development_stage" placeholder="Select value..."  chips closable-chips  :items="dict.development_stage" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Is your solution a branded consumer product? <sup class="required">*</sup></span>
          <div class="info_startup_2 dblock" >
            <label class="rocker ">
                <input type="checkbox" v-model="startup.full_brand" >
                <span class="switch-left">YES</span>
                <span class="switch-right">NO</span>
                </label>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What is the Technology Readiness Level (TRL) of your solution?</span>
          <div class="info_startup_2" >
            <input type="number" min="1" max="9" class="info_value" name="name" placeholder="TRL" v-model="startup.TRL"/>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Have you validated the market demand?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-select v-model='startup.market_validation' :items="[{value:true,display:'YES'},{value:false,display:'NO'}]"  item-title="display"  item-value="value"/>

            <!-- <v-autocomplete v-model="startup.market_fit_evidence" placeholder="Select value..." chips closable-chips  :items="dict.market_fit_evidence" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete> -->
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Innovation category<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.product_category" placeholder="Select value..." chips closable-chips multiple  :items="dict.product_category" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
            <span class="lengthIndicator" v-if="startup.product_category">{{startup.product_category.length}} / 5 choices</span>

          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Choose the primary aspect of your innovation, such as product, technology, service, process, or business model</span>

           </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Innovation area<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.innovation_area" placeholder="Select value..." chips closable-chips :items="dict.innovation_areas" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
            <span class="lengthIndicator" v-if="startup.innovation_area">{{startup.innovation_area.length}} / 5 choices</span>

          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Specify the particular domains where your innovation efforts are directed</span>
           </span>
        </div>


        <!-- NEW FIELD -->

        <div class="oneField">
          <span class="fieldTitle">Data available</span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.data_available" placeholder="Select value..." chips closable-chips :items="dict.data_available" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Check all that applies</span>
           </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Regulatory status</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="List agencies (FDA, EPA, GRAS, etc) and locations (US, EU, etc.)" v-model="startup.regulatory_status"></textarea>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">List agencies (FDA, EPA, GRAS, etc) and locations (US, EU, etc.)</span>
           </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Patents granted/applied</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="List patent numbers, status and countries" v-model="startup.patents"></textarea>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">List patent numbers, status and countries</span>
           </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Other forms of protection</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="Other forms of protection" v-model="startup.other_protections"></textarea>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">What is the addressable market for your solution? </span>
          <div class="info_startup_2 flexh" >
              <input type="text" class="info_value info_value_investment" name="name" v-model="startup.market_potential.value"/>
              <select class="selectDevise" v-model="startup.market_potential.unit" >
                <option disabled value="">Unit</option>
                <!-- <option>K</option> -->
                <option>M</option>
                <!-- <option>Bn</option> -->
              </select>
              <select class="selectDevise" v-model="startup.market_potential.currency">
                <option disabled value="">Currency</option>
                <option>EUR</option>
                <option>USD</option>
                <option>£</option>
                <option>CHF</option>
              </select>
            </div>
            <span class="explaination">
               <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>Ex. 0,04 M USD for 40 000 dollars.
             </span>
        </div>


      </div>


      <div class="v-card-content" v-if="step == 3" :id="'step-'+step">

        <div class="oneField">
          <span class="fieldTitle">What is your business model? <sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.business_model" chips closable-chips  :items="dict.business_model" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>

          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Do you have paying customers?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-select v-model='startup.paying_customers' :items="[{value:true,display:'YES'},{value:false,display:'NO'}]"  item-title="display"  item-value="value"/>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Tell us about your reference customers<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" v-model="startup.main_clients" placeholder="Companies' names"></textarea>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What are the benefits of your solution for consumers or customers?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete  v-model="startup.key_benefits" placeholder="Select value..." chips closable-chips  :items="dict.key_benefits" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Which 3 KPIs measure the success of your solution?</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="Ex. 15% energy saving" v-model="startup.key_benefits_kpi"></textarea>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What is the CO2 impact of your solution?</span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.sustainability_impact" placeholder="Select value..." chips closable-chips :items="dict.sustainability_impact"  item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
        </div>



      </div>


      <div class="v-card-content" v-if="step == 4" :id="'step-'+step">

        <div class="oneField">
          <span class="fieldTitle">How many people work at the company?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="number"  class="info_value w100" name="team_size" min="0" v-model="startup.team_size"/>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What type of IP do you have?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.IP" chips closable-chips placeholder="Select value..."  :items="dict.ip" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
        </div>

      <div class="oneField">

        <span class="fieldTitle">Where is your solution currently deployed?<sup class="required">*</sup></span>
        <div class="info_startup_2" >
          <v-autocomplete v-model="startup.markets" chips closable-chips placeholder="Select value..." :items="dict.markets" multiple item-color="#FFF" item-title="name" item-value="value" :menu-props="{ maxWidth: 0 }" return-object></v-autocomplete>
        </div>
        <span class="explaination">
           <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
           <span class="ml5">Region / Country</span>
         </span>
      </div>
      <div class="oneField">
        <span class="fieldTitle">Tell us more about your skills and expertise</span>
        <div class="info_startup_2" >
          <v-autocomplete v-model="startup.skills" chips closable-chips placeholder="Select value..."  :items="dict.skills" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>
        </div>
        <span class="explaination">
           <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
           <span class="ml5">Highlight your unique strengths or competencies</span>
         </span>
      </div>

        <div class="oneField">
          <span class="fieldTitle">What type of assets do you have? </span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.assets" chips closable-chips placeholder="Select value..." :items="dict.type_of_assets" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Highlight relevant resources you own or control</span>
           </span>
        </div>





      </div>

      <div class="v-card-content" v-if="step == 5" :id="'step-'+step">
        <div class="oneField">
          <span class="fieldTitle">How much funding have you raised?</span>
          <div class="info_startup_2 flexh" >
            <input type="text" class="info_value info_value_investment" name="name" v-model="startup.investment_raised.value"/>
            <select class="selectDevise" v-model="startup.investment_raised.unit">
              <option disabled value="">Unit</option>
              <!-- <option>k</option> -->
              <option>M</option>
              <!-- <option>Bn</option> -->
            </select>
            <select class="selectDevise" v-model="startup.investment_raised.currency">
              <option disabled value="">Currency</option>
              <option>EUR</option>
              <option>USD</option>
              <option>£</option>
              <option>CHF</option>
            </select>

          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>Ex. 5 M USD for 5 000 0000 dollars
           </span>
        </div>


         <div class="oneField">
          <span class="fieldTitle">Last funding round<sup class="required">*</sup></span>
          <div class="info_startup_2 " >
            <v-autocomplete v-model="startup.funding_stage" chips closable-chips  :items="dict.funding_stage" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>

          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">If you've secured funding, tell us about your investors</span>
          <div class="info_startup_2" >
            <textarea ref="solution" placeholder="Mention your investors" @input="resize('solution')" name="name" rows="4" cols="30" v-model="startup.investors"></textarea>
          </div>
        </div>



        <div class="oneField" >
          <span class="fieldTitle">What was  your revenue last year?  <sup class="required">*</sup> </span>
          <div class="selectIt">
            <label>
              <input type="checkbox" v-model="startup.no_revenue_yet" >
              <span>No revenue yet</span>
            </label>
          </div>
          <div class="realRevenueInput" v-if="!startup.no_revenue_yet">
            <div class="info_startup_2 flexh" >
              <input type="text" class="info_value info_value_investment" name="name" v-model="startup.revenue.value"/>
              <select class="selectDevise" v-model="startup.revenue.unit">
                <option disabled value="">Unit</option>
                <!-- <option>k</option> -->
                <option>M</option>
                <!-- <option>Bn</option> -->
              </select>
              <select class="selectDevise" v-model="startup.revenue.currency">
                <option disabled value="">Currency</option>
                <option>EUR</option>
                <option>USD</option>
                <option>£</option>
                <option>CHF</option>
              </select>
            </div>
            <span class="explaination">
               <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
               <span class="ml5">Providing your revenue helps us determine the optimal collaboration model</span>
             </span>
          </div>

        </div>


        <div class="oneField">
          <span class="fieldTitle">What type of partnership are you looking for? </span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.partnership_objectives" chips closable-chips  :items="dict.partnership_objectives" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle ">Presentation deck</span>
          <input type="text"  class="info_value" name="pitchdeck_link" placeholder="Link to your presentation material" v-model="startup.pitchdeck_link"/>

          <div class="presentationDeck 2halfs">
            <div class="oneHalf">
              <span class="fieldSubTitle">PDF</span>
              <FileUploader :startup="startup._id.$oid" fileType="pitchdeck" @fileUploaded="fileIsUpload"/>
              <span class="explaination">
                 <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
                 <span class="ml5">Size limit: 5MB</span>
               </span>
            </div>
            <div class="oneHalf" v-if='startup.presentation_deck_file '>
              <table class="table table_brief_doc">
                <thead>
                  <tr>
                    <td colspan="2" class="text-center"><span class="zone_input_name">Your current presentation deck</span></td>
                  </tr>
                </thead>
                <tbody>
                  <tr class="">
                    <td> <a :href="this.apiUrl+'/get_public_file/'+startup.presentation_deck_file._id.$oid" target="_blank">{{startup.presentation_deck_file.customer_filename}}</a></td>
                    <td class="text-right">
                      <a class="tblue" :href="this.apiUrl+'/get_public_file/'+startup.presentation_deck_file._id.$oid" target="_blank">
                        <v-icon icon="mdi:mdi-file-eye-outline" style="font-size: 18px;"/>
                      </a>
                      <button style="margin-left:15px;" @click="deleteFile(startup.presentation_deck_file._id.$oid)">
                        <v-icon icon="mdi:mdi-trash-can-outline" style="font-size: 18px;"/>
                      </button>
                  </td>
                  </tr>
                </tbody>

              </table>

            </div>
          </div>

        </div>

        <div class="oneField">
          <span class="fieldTitle">Additional Information</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="Include URLs to external videos " v-model="startup.additional_info"></textarea>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Include URLs to external videos </span>
           </span>
        </div>

      </div>
      <div class="v-card-content" v-if="step == 6" :id="'step-'+step">
        <div class="oneField">
          <span class="fieldTitle">Key contact<sup class="required">*</sup></span>

          <div class="subfields">
            <div class="oneField">
              <span class="fieldSubTitle">Name<sup class="required">*</sup></span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_name" placeholder="Fullname" v-model="startup.key_contact_name"/>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">Role<sup class="required">*</sup></span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_role" v-model="startup.key_contact_role"/>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">Email<sup class="required">*</sup></span>
              <div class="info_startup_2" >
                <input type="email" class="info_value" name="key_contact_email" v-model="startup.key_contact_email"/>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">Phone number<sup class="required">*</sup></span>
              <div class="info_startup_2" >
                <vue-tel-input class="info_value" name="key_contact_phone" v-model="startup.key_contact_phone"  v-bind="bindProps"></vue-tel-input>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">LinkedIn profile</span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_linkedin" v-model="startup.key_contact_linkedin"/>
              </div>
            </div>

            <div class="oneField">
              <span class="fieldSubTitle">Calendar link</span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_linkedin" v-model="startup.key_contact_calendar_link"/>
              </div>
            </div>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Other contacts</span>
          <div class="info_startup_2" >
            <div class="listOfContacts" v-if="isThereFounders(startup.contacts)">
              <table class="table">
                <tbody>
                  <tr class="" v-for='(f,i) in startup.contacts' :key="i">
                    <td>   {{f.name}} </td>
                    <td>   {{f.position}} </td>
                    <td>   {{f.phone}} </td>
                    <td>   {{f.email}} </td>
                    <td class="text-right">
                      <a v-if="founderLink(f.calendar_link)" :href="founderLink(f.calendar_link)" target="_blank" class="picto_link_linkedin"><v-icon icon="mdi:mdi-calendar-clock" style="font-size: 20px;"/></a>

                      <a v-if="founderLink(f.linkedin_profile)" :href="founderLink(f.linkedin_profile)" target="_blank" class="picto_link_linkedin"><v-icon icon="mdi:mdi-linkedin" style="font-size: 20px;"/></a>
                      <button @click="removeContact(f,i)" class="trashFounder"><v-icon icon="mdi:mdi-trash-can-outline" style="font-size: 18px;"/></button>

                  </td>
                  </tr>
                </tbody>

              </table>


            </div>
            <div class="subfields">
              <div class="oneField">
                <span class="fieldSubTitle">Name<sup class="required">*</sup></span>
                <input type="text" class="info_value" placeholder="Full name" name="name" v-model="newcontact.name" />
                <div class="alert alert-warning text-left mt-1 " v-if="v$.newcontact.email.$errors.length > 0">
                    <div  v-for="(error, index) of v$.newcontact.email.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Role<sup class="required">*</sup></span>
                <input type="text" class="info_value" name="name" v-model="newcontact.position" placeholder="Role"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.newcontact.position.$errors.length > 0">
                    <div  v-for="(error, index) of v$.newcontact.position.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Email<sup class="required">*</sup></span>
                <input type="email" class="info_value" name="key_contact_email" v-model="newcontact.email" placeholder="Email"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.newcontact.email.$errors.length > 0">
                    <div  v-for="(error, index) of v$.newcontact.email.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>

              <div class="oneField">
                <span class="fieldSubTitle">Phone number</span>
                <vue-tel-input class="info_value" name="key_contact_phone" v-model="newcontact.phone"  v-bind="bindProps"></vue-tel-input>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Linkedin Profile</span>
                <input type="text" class="info_value" name="name"  v-model="newcontact.linkedin_profile" placeholder="Linkedin profile"/>
              </div>

              <div class="">
                <button type="button" class="addValue" @click="addContact()" name="button">Validate the contact</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="vactions right_actions">
        <div class="flexLeft">
          <button class="addValue_invert" @click="prev_step()" :disabled="step <= 1">
            Previous
          </button>
        </div>


        <div class="flexRight">
          <button class="addValue" @click="save">
            Save
          </button>

          <button class="addValue_invert" @click="next_step()" :disabled="step >= 6">
            Next
          </button>
        </div>

      </div>
    </v-card>

    <v-card v-if="what == 'summary'">
      <v-card-title>
          Summary
      </v-card-title>
      <div class="v-card-content">
        <div class="oneField">
          <span class="fieldTitle">Company type<sup class="required">*</sup></span>
          <v-autocomplete v-model="startup.company_type" chips closable-chips  :items="dict.company_type" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.company_type.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.company_type.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What are the main application domains of your solution?<sup class="required">*</sup></span>
          <v-autocomplete v-model="startup.application_area" chips closable-chips  :items="dict.application_areas" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.application_area.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.application_area.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Pitch your company<sup class="required">*</sup></span>
          <div class="info_startup_2">
            <textarea ref="value_proposition" @input="resize('value_proposition')" name="name" rows="4" cols="30" v-model="startup.value_proposition"></textarea>
            <span class="lengthIndicator" v-if="startup.value_proposition">
              <span v-if="startup.value_proposition.length <= 700">Caracters: {{startup.value_proposition.length}} / 700</span>
              <strong v-else class="tred">Character limit exceeded.<br/>Maximum number of characters exceeded. You can continue to edit but will have to shorten the text before submission.</strong>
            </span>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.value_proposition.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.value_proposition.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Tell us more about your solution<sup class="required">*</sup></span>
          <div class="info_startup_2">
            <textarea ref="solution" @input="resize('solution')" name="name" rows="4" cols="30" v-model="startup.solution"></textarea>
            <span class="lengthIndicator" v-if="startup.solution">
              <span v-if="startup.solution.length <= 700">Caracters: {{startup.solution.length}} / 700</span>
              <strong v-else class="tred">Character limit exceeded.<br/>Maximum number of characters exceeded. You can continue to edit but will have to shorten the text before submission.</strong>
            </span>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.solution.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.solution.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>
<!--
        <div class="oneField">
          <span class="fieldTitle">Last funding round</span>
          <v-autocomplete v-model="startup.funding_stage" chips closable-chips  :items="dict.funding_stage" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
        </div> -->

        <div class="oneField" >
          <span class="fieldTitle">What was  your revenue last year? <sup class="required">*</sup></span>
          <div class="selectIt">
            <label>
              <input type="checkbox" v-model="startup.no_revenue_yet" >
              <span>No revenue yet</span>
            </label>
          </div>
              <div class="realRevenueInput" v-if='!startup.no_revenue_yet'>
          <div class="info_startup_2 flexh" >
              <input type="text" class="info_value info_value_investment" name="name" v-model="startup.revenue.value"/>
              <select class="selectDevise" v-model="startup.revenue.unit">
                <option disabled value="">Unit</option>
                <!-- <option>K</option> -->
                <option>M</option>
                <!-- <option>Bn</option> -->
              </select>
              <select class="selectDevise" v-model="startup.revenue.currency">
                <option disabled value="">Currency</option>
                <option>EUR</option>
                <option>USD</option>
                <option>£</option>
                <option>CHF</option>
              </select>
            </div>
            <span class="explaination">
               <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>Provide an indication of your revenue<br/>
               Ex. 0,04 M USD for 40 000 dollars.
             </span>
             <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.revenue.$errors.length > 0">
                 <div  v-for="(error, index) of v$.startup.revenue.$errors" :key="index">{{ error.$message }}</div>
             </div>
           </div>
          </div>

          <div class="oneField">
            <span class="fieldTitle">What is the size of your team?</span>
            <div class="info_startup_2" >
              <input type="number"  class="info_value w100" name="team_size" min="0" v-model="startup.team_size"/>
            </div>
          </div>

          <div class="oneField">
            <span class="fieldTitle">Where are you based?<sup class="required">*</sup></span>
            <div class="info_startup_2" >
              <treeselect v-model="startup.location" :multiple="true" :options="dict.location" />
            </div>
            <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.location.$errors.length > 0">
                <div  v-for="(error, index) of v$.startup.location.$errors" :key="index">{{ error.$message }}</div>
            </div>
          </div>


      </div>

      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>

    <v-card v-if="what == 'company'">
      <v-card-title>
          Company
      </v-card-title>
      <div class="v-card-content">
        <div class="oneField">
          <span class="fieldTitle">Organization name<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="startupname" placeholder="Organization name" v-model="startup.name"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.name.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.name.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Foundation year<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="number" min="1900" class="info_value" name="name" placeholder="Foundation year" v-model="startup.company_founded_year"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.company_founded_year.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.company_founded_year.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
         <span class="fieldTitle">Last funding round<sup class="required">*</sup></span>
         <div class="info_startup_2 " >
           <v-autocomplete v-model="startup.funding_stage" chips closable-chips  :items="dict.funding_stage" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>

         </div>
         <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.funding_stage.$errors.length > 0">
             <div  v-for="(error, index) of v$.startup.funding_stage.$errors" :key="index">{{ error.$message }}</div>
         </div>
       </div>

        <div class="oneField">
          <span class="fieldTitle">Website URL<sup class="required">*</sup>
          <br/><small>Your link must be secure include https://</small></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="name" v-model="startup.website" @input="toLowercase" placeholder="Ex: https://innopearl.ch"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.website.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.website.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Who are the founders?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <div class="listOfFounders" v-if="isThereFounders(startup.founders)">
              <table class="table">
                <tbody>
                  <tr class="" v-for='(f,i) in startup.founders' :key="i">
                    <td>   {{f.name}} <span v-if="f.position">- {{f.position}}</span></td>
                    <td class="text-right">
                      <a v-if="founderLink(f.linkedin_profile)" :href="founderLink(f.linkedin_profile)" target="_blank" class="picto_link_linkedin"><v-icon icon="mdi:mdi-linkedin" style="font-size: 20px;"/></a>
                      <button @click="removeFounder(f,i)" class="trashFounder"><v-icon icon="mdi:mdi-trash-can-outline" style="font-size: 18px;"/></button>

                  </td>
                  </tr>
                </tbody>

              </table>


            </div>
            <div class="subfields">
              <div class="oneField">
                <span class="fieldSubTitle">Name<sup class="required">*</sup></span>
                <input type="text" class="info_value" name="name" v-model="founder.name" placeholder="Name"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.founder.name.$errors.length > 0">
                    <div  v-for="(error, index) of v$.founder.name.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Role<sup class="required">*</sup></span>
                <input type="text" class="info_value" name="name" v-model="founder.position" placeholder="Role"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.founder.position.$errors.length > 0">
                    <div  v-for="(error, index) of v$.founder.position.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Linkedin Profile</span>
                <input type="text" class="info_value" name="name"  v-model="founder.linkedin_profile" placeholder="Linkedin profile"/>
              </div>
              <div class="">
                <button type="button" class="addValue" @click="addFounder()" name="button">Validate the founder</button>
              </div>
            </div>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.founders.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.founders.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Where are you based?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <treeselect v-model="startup.location" :multiple="true" :options="dict.location" placehoder="Where are you based?"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.location.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.location.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">LinkedIn Company page</span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="linkedin_profile" v-model="startup.linkedin_profile" placeholder="LinkedIn Profile"/>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Calendar link</span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="linkedin_profile" v-model="startup.calendar_link" placeholder="Link to your calendar"/>
          </div>
        </div>



      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>
    <v-card v-if="what == 'contact'">
      <v-card-title>
          Contact information
      </v-card-title>
      <div class="v-card-content">

        <div class="oneField">
          <span class="fieldTitle">Organization name<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="text" class="info_value" name="startupname" v-model="startup.name"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.name.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.name.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>


          <div class="oneField">
            <span class="fieldTitle">Key contact name<sup class="required">*</sup></span>
            <div class="info_startup_2" >
              <input type="text" class="info_value" name="key_contact_name" placeholder="Fullname" v-model="startup.key_contact_name"/>
            </div>
            <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.key_contact_name.$errors.length > 0">
                <div  v-for="(error, index) of v$.startup.key_contact_name.$errors" :key="index">{{ error.$message }}</div>
            </div>
          </div>

          <div class="oneField">
            <span class="fieldTitle">Key contact email<sup class="required">*</sup></span>
            <div class="info_startup_2" >
              <input type="email" class="info_value" name="key_contact_email" v-model="startup.key_contact_email"/>
            </div>
            <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.key_contact_email.$errors.length > 0">
                <div  v-for="(error, index) of v$.startup.key_contact_email.$errors" :key="index">{{ error.$message }}</div>
            </div>
          </div>

          <div class="oneField">
            <span class="fieldTitle">Key contact phone<sup class="required">*</sup></span>
            <div class="info_startup_2" >
              <vue-tel-input class="info_value" name="key_contact_phone" v-model="startup.key_contact_phone"  v-bind="bindProps"></vue-tel-input>
            </div>
            <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.key_contact_phone.$errors.length > 0">
                <div  v-for="(error, index) of v$.startup.key_contact_phone.$errors" :key="index">{{ error.$message }}</div>
            </div>
          </div>

          <div class="oneField">
            <span class="fieldTitle">Website<sup class="required">*</sup></span>
            <div class="info_startup_2" >
              <input type="text" class="" name="name" v-model="startup.website" @input="toLowercase" placeholder="website"/>
            </div>
            <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.website.$errors.length > 0">
                <div  v-for="(error, index) of v$.startup.website.$errors" :key="index">{{ error.$message }}</div>
            </div>
          </div>

      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>

    <v-card v-if="what == 'capabilities'">
      <v-card-title>
          Capabilities
      </v-card-title>
      <div class="v-card-content">
        <div class="oneField">
          <span class="fieldTitle">Woman co-founder<sup class="required">*</sup></span>
          <div class="info_startup_2 dblock" >
            <label class="rocker mt20 ml20">
        <input type="checkbox" v-model="startup.woman_cofounder" >
        <span class="switch-left">YES</span>
        <span class="switch-right">NO</span>
      </label>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.woman_cofounder.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.woman_cofounder.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Team size<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <input type="number"  class="info_value" name="team_size" min="0" v-model="startup.team_size"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.team_size.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.team_size.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Tell us more about your core capabilities</span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.skills" chips closable-chips  :items="dict.skills" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Select unique strengths or competencies that enable you to create value</span>
           </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What type of assets do you have?</span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.assets" chips closable-chips placeholder="Select value..." :items="dict.type_of_assets" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Select resources you own or control</span>
           </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What type of IP do you have?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.IP" chips closable-chips placeholder="Select value..."  :items="dict.ip" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.IP.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.IP.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>


      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>


    <v-card v-if="what == 'solution'">
      <v-card-title>
          Solution
      </v-card-title>
      <div class="v-card-content">
        <div class="oneField">
          <span class="fieldTitle">Innovation category<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.product_category" chips closable-chips  :items="dict.product_category" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
            <span class="explaination">
               <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
               <span class="ml5">Choose the primary aspect of your innovation, such as product, technology, service, process, or business model</span>

             </span>
          </div>

          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.product_category.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.product_category.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Innovation area<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.innovation_area" placeholder="Select value..." chips closable-chips :items="dict.innovation_areas" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Specify the particular domains where your innovation efforts are directed</span>
           </span>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.innovation_area.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.innovation_area.$errors" :key="index">{{ error.$message }}</div>
          </div>

        </div>

        <div class="oneField">
          <span class="fieldTitle">Pitch your company<sup class="required">*</sup></span>
          <div class="info_startup_2">
            <textarea ref="value_proposition" placeholder="Pitch your company" @input="resize('value_proposition')" name="name" rows="4" cols="30" v-model="startup.value_proposition"></textarea>
            <span class="lengthIndicator" v-if="startup.value_proposition">
              <span v-if="startup.value_proposition.length <= 700">Caracters: {{startup.value_proposition.length}} / 700</span>
              <strong v-else class="tred">Character limit exceeded.<br/>Maximum number of characters exceeded. You can continue to edit but will have to shorten the text before submission.</strong>
            </span>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.value_proposition.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.value_proposition.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Tell us more about your solution<sup class="required">*</sup></span>
          <div class="info_startup_2">
            <textarea ref="solution" placeholder="What solution do you provide?" @input="resize('solution')" name="name" rows="4" cols="30" v-model="startup.solution"></textarea>
            <span class="lengthIndicator" v-if="startup.solution">
              <span v-if="startup.solution.length <= 700">Caracters: {{startup.solution.length}} / 700</span>
              <strong v-else class="tred">Character limit exceeded.<br/>Maximum number of characters exceeded. You can continue to edit but will have to shorten the text before submission.</strong>
            </span>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.solution.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.solution.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <!-- NEW FIELD -->
        <div class="oneField">
          <span class="fieldTitle">Data available</span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.data_available" placeholder="Select value..." chips closable-chips :items="dict.data_available" multiple item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Check all that applies</span>
           </span>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Regulatory status</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="List agencies (FDA, EPA, GRAS, etc) and locations (US, EU, etc.)" v-model="startup.regulatory_status"></textarea>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Patents granted/applied</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="List patent numbers, status and countries" v-model="startup.patents"></textarea>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Other forms of protection</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="Other forms of protection" v-model="startup.other_protections"></textarea>
          </div>
        </div>



        <div class="oneField">
          <span class="fieldTitle">What is the CO2 impact of your solution?</span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.sustainability_impact" placeholder="Select value..." chips closable-chips :items="dict.sustainability_impact"  item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What are the benefits of your solution for consumers or customers?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete  v-model="startup.key_benefits" placeholder="Select value..." chips closable-chips  :items="dict.key_benefits" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.key_benefits.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.key_benefits.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Which 3 KPIs measure the success of your solution?</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="Ex. 15% energy saving " v-model="startup.key_benefits_kpi"></textarea>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle ">Presentation deck</span>
          <input type="text"  class="info_value" name="pitchdeck_link" placeholder="Link to your presentation material" v-model="startup.pitchdeck_link"/>

          <div class="presentationDeck 2halfs">
            <div class="oneHalf">
              <span class="fieldSubTitle">PDF</span>
              <FileUploader :startup="startup._id.$oid" fileType="pitchdeck" @fileUploaded="fileIsUpload"/>
              <span class="explaination">
                 <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
                 <span class="ml5">Size limit: 5MB</span>
               </span>
            </div>
            <div class="oneHalf"  v-if='startup.presentation_deck_file '>
              <table class="table table_brief_doc">
                <thead>
                  <tr>
                    <td colspan="2" class="text-center"><span class="zone_input_name">Your current presentation deck</span></td>
                  </tr>
                </thead>
                <tbody>
                  <tr class="">
                    <td> <a :href="this.apiUrl+'/get_public_file/'+startup.presentation_deck_file._id.$oid" target="_blank">{{startup.presentation_deck_file.customer_filename}}</a></td>
                    <td class="text-right">
                      <a class="tblue" :href="this.apiUrl+'/get_public_file/'+startup.presentation_deck_file._id.$oid" target="_blank">
                        <v-icon icon="mdi:mdi-file-eye-outline" style="font-size: 18px;"/>
                      </a>
                      <button style="margin-left:15px;" @click="deleteFile(startup.presentation_deck_file._id.$oid)">
                        <v-icon icon="mdi:mdi-trash-can-outline" style="font-size: 18px;"/>
                      </button>
                  </td>
                  </tr>
                </tbody>

              </table>

            </div>
          </div>

        </div>


        <div class="oneField">
          <span class="fieldTitle">What is the Technology Readiness Level (TRL) of your solution?</span>
          <div class="info_startup_2" >
            <input type="number" min="1" max="9"  class="info_value" name="name" placeholder="TRL" v-model="startup.TRL"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.TRL.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.TRL.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Is your solution a branded consumer product?<sup class="required">*</sup></span>
          <div class="info_startup_2 dblock" >
            <label class="rocker ">
                <input type="checkbox" v-model="startup.full_brand" >
                <span class="switch-left">YES</span>
                <span class="switch-right">NO</span>
                </label>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.full_brand.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.full_brand.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <!-- <div class="oneField">
          <span class="fieldTitle">Have you validated the market demand?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.market_fit_evidence" placeholder="Select value..." chips closable-chips  :items="dict.market_fit_evidence" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
        </div> -->


      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>


    <v-card v-if="what == 'traction'">
      <v-card-title>
          Traction
      </v-card-title>
      <div class="v-card-content">


        <div class="oneField">
          <span class="fieldTitle">What is your innovation's commercial development stage?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.development_stage" placeholder="Select value..."  chips closable-chips  :items="dict.development_stage" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.development_stage.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.development_stage.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>


                 <!-- <div class="oneField">
                  <span class="fieldTitle">Last funding round<sup class="required">*</sup></span>
                  <div class="info_startup_2 " >
                    <v-autocomplete v-model="startup.funding_stage" chips closable-chips  :items="dict.funding_stage" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>

                  </div>
                  <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.funding_stage.$errors.length > 0">
                      <div  v-for="(error, index) of v$.startup.funding_stage.$errors" :key="index">{{ error.$message }}</div>
                  </div>
                </div> -->


        <div class="oneField">
          <span class="fieldTitle">If you've secured funding, tell us about your investors</span>
          <div class="info_startup_2" >
            <textarea ref="solution" placeholder="Mention your investors" @input="resize('solution')" name="name" rows="4" cols="30" v-model="startup.investors"></textarea>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Where is your solution currently deployed?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.markets" chips closable-chips placeholder="Select value..." :items="dict.markets" multiple item-color="#FFF" item-title="name" item-value="value" :menu-props="{ maxWidth: 0 }" return-object></v-autocomplete>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Region / Country</span>
           </span>
           <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.markets.$errors.length > 0">
               <div  v-for="(error, index) of v$.startup.markets.$errors" :key="index">{{ error.$message }}</div>
           </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What was your revenue last year?<sup class="required">*</sup> </span>
          <div class="info_startup_2 flexh" >
            <input type="text" class="info_value info_value_investment" name="name" v-model="startup.revenue.value"/>
            <select class="selectDevise" v-model="startup.revenue.unit">
              <option disabled value="">Unit</option>
              <!-- <option>k</option> -->
              <option>M</option>
              <!-- <option>Bn</option> -->
            </select>
            <select class="selectDevise" v-model="startup.revenue.currency">
              <option disabled value="">Currency</option>
              <option>EUR</option>
              <option>USD</option>
              <option>£</option>
              <option>CHF</option>
            </select>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>Ex. 100 K USD for 100 000 dollars.
           </span>
           <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.revenue.$errors.length > 0">
               <div  v-for="(error, index) of v$.startup.revenue.$errors" :key="index">{{ error.$message }}</div>
           </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">How much funding have you raised?</span>
          <div class="info_startup_2 flexh" >
            <input type="text" class="info_value info_value_investment" name="name" v-model="startup.investment_raised.value"/>
            <select class="selectDevise" v-model="startup.investment_raised.unit">
              <option disabled value="">Unit</option>
              <!-- <option>k</option> -->
              <option>M</option>
              <!-- <option>Bn</option> -->
            </select>
            <select class="selectDevise" v-model="startup.investment_raised.currency">
              <option disabled value="">Currency</option>
              <option>EUR</option>
              <option>USD</option>
              <option>£</option>
              <option>CHF</option>
            </select>

          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>Ex. 5 M USD for 5 000 0000 dollars.
           </span>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Do you have paying customers?<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-select v-model='startup.paying_customers' :items="[{value:true,display:'YES'},{value:false,display:'NO'}]"  item-title="display"  item-value="value"/>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.paying_customers.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.paying_customers.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Tell us about your reference customers<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" v-model="startup.main_clients" placeholder="Company naame"></textarea>
          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.main_clients.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.main_clients.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Business model<sup class="required">*</sup></span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.business_model" chips closable-chips  :items="dict.business_model" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>

          </div>
          <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.business_model.$errors.length > 0">
              <div  v-for="(error, index) of v$.startup.business_model.$errors" :key="index">{{ error.$message }}</div>
          </div>
        </div>

        <div class="oneField">
          <span class="fieldTitle">What is the size of the addressable market for your solution?</span>
          <div class="info_startup_2 flexh" >
              <input type="text" class="info_value info_value_investment" name="name" v-model="startup.market_potential.value"/>
              <select class="selectDevise" v-model="startup.market_potential.unit" >
                <option disabled value="">Unit</option>
                <!-- <option>K</option> -->
                <option>M</option>
                <!-- <option>Bn</option> -->
              </select>
              <select class="selectDevise" v-model="startup.market_potential.currency">
                <option disabled value="">Currency</option>
                <option>EUR</option>
                <option>USD</option>
                <option>£</option>
                <option>CHF</option>
              </select>
            </div>
            <span class="explaination">
               <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>Ex. 0,04 M USD for 40 000 dollars.
             </span>
        </div>

        <div class="oneField">
          <span class="fieldTitle">Have you validated the market demand?</span>
          <div class="info_startup_2" >
            <v-select v-model='startup.market_validation' :items="[{value:true,display:'YES'},{value:false,display:'NO'}]"  item-title="display"  item-value="value"/>

            <!-- <v-autocomplete v-model="startup.market_fit_evidence" placeholder="Select value..." chips closable-chips  :items="dict.market_fit_evidence" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete> -->
          </div>
        </div>


        <!-- <div class="oneField">
          <span class="fieldTitle">What type of sustainability impact does your solution provide?</span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.sustainability_impact" placeholder="Select value..." chips closable-chips :items="dict.sustainability_impact"  item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
          </div>
        </div> -->


      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>


    <v-card v-if="what == 'goals'">
      <v-card-title>
          Goals
      </v-card-title>
      <div class="v-card-content">
        <div class="oneField">
          <span class="fieldTitle">What type of partnership are you looking for? </span>
          <div class="info_startup_2" >
            <v-autocomplete v-model="startup.partnership_objectives" chips closable-chips  :items="dict.partnership_objectives" item-color="#FFF" item-title="name" item-value="value" multiple return-object></v-autocomplete>
          </div>
        </div>
        <div class="oneField">
          <span class="fieldTitle">Additional Information</span>
          <div class="info_startup_2" >
            <textarea name="name" rows="2" cols="30" placeholder="Include URLs to external videos " v-model="startup.additional_info"></textarea>
          </div>
          <span class="explaination">
             <v-icon icon="mdi:mdi-bullseye-arrow" style="font-size: 18px;"/>
             <span class="ml5">Include URLs to external videos </span>
           </span>
        </div>


      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>


    <v-card v-if="what == 'contacts'">
      <v-card-title>
          Contacts
      </v-card-title>
      <div class="v-card-content">
        <div class="oneField">
          <span class="fieldTitle">Key contact<sup class="required">*</sup></span>

          <div class="subfields">
            <div class="oneField">
              <span class="fieldSubTitle">Name<sup class="required">*</sup></span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_name" placeholder="Fullname" v-model="startup.key_contact_name"/>
              </div>
              <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.key_contact_name.$errors.length > 0">
                  <div  v-for="(error, index) of v$.startup.key_contact_name.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">Role</span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_role" v-model="startup.key_contact_role"/>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">Email<sup class="required">*</sup></span>
              <div class="info_startup_2" >
                <input type="email" class="info_value" name="key_contact_email" v-model="startup.key_contact_email"/>
              </div>
              <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.key_contact_email.$errors.length > 0">
                  <div  v-for="(error, index) of v$.startup.key_contact_email.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">Phone number<sup class="required">*</sup></span>
              <div class="info_startup_2" >
                <vue-tel-input class="info_value" name="key_contact_phone" v-model="startup.key_contact_phone"  v-bind="bindProps"></vue-tel-input>
              </div>
              <div class="alert alert-warning text-left mt-1 " v-if="v$.startup.key_contact_phone.$errors.length > 0">
                  <div  v-for="(error, index) of v$.startup.key_contact_phone.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">LinkedIn profile</span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_linkedin" v-model="startup.key_contact_linkedin"/>
              </div>
            </div>
            <div class="oneField">
              <span class="fieldSubTitle">Calendar link</span>
              <div class="info_startup_2" >
                <input type="text" class="info_value" name="key_contact_linkedin" v-model="startup.key_contact_calendar_link"/>
              </div>
            </div>
          </div>
        </div>


        <div class="oneField">
          <span class="fieldTitle">Other contacts</span>
          <div class="info_startup_2" >
            <div class="listOfContacts" v-if="isThereFounders(startup.contacts)">
              <table class="table">
                <tbody>
                  <tr class="" v-for='(f,i) in startup.contacts' :key="i">
                    <td>   {{f.name}} </td>
                    <td>   {{f.position}} </td>
                    <td>   {{f.phone}} </td>
                    <td>   {{f.email}} </td>
                    <td class="text-right">
                      <a v-if="founderLink(f.linkedin_profile)" :href="founderLink(f.linkedin_profile)" target="_blank" class="picto_link_linkedin"><v-icon icon="mdi:mdi-linkedin" style="font-size: 20px;"/></a>
                      <button @click="removeContact(f,i)" class="trashFounder"><v-icon icon="mdi:mdi-trash-can-outline" style="font-size: 18px;"/></button>

                  </td>
                  </tr>
                </tbody>

              </table>


            </div>
            <div class="subfields">
              <div class="oneField">
                <span class="fieldSubTitle">Name<sup class="required">*</sup></span>
                <input type="text" class="info_value" name="name" v-model="newcontact.name" placeholder="Full name"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.newcontact.name.$errors.length > 0">
                    <div  v-for="(error, index) of v$.newcontact.name.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Role<sup class="required">*</sup></span>
                <input type="text" class="info_value" name="name" v-model="newcontact.position" placeholder="Role"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.newcontact.position.$errors.length > 0">
                    <div  v-for="(error, index) of v$.newcontact.position.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Email<sup class="required">*</sup></span>
                <input type="email" class="info_value" name="key_contact_email" v-model="newcontact.email" placeholder="Email"/>
                <div class="alert alert-warning text-left mt-1 " v-if="v$.newcontact.email.$errors.length > 0">
                    <div  v-for="(error, index) of v$.newcontact.email.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>

              <div class="oneField">
                <span class="fieldSubTitle">Phone</span>
                <vue-tel-input class="info_value" name="key_contact_phone" v-model="newcontact.phone"  v-bind="bindProps"></vue-tel-input>
              </div>
              <div class="oneField">
                <span class="fieldSubTitle">Linkedin profile</span>
                <input type="text" class="info_value" name="name"  v-model="newcontact.linkedin_profile" placeholder="Linkedin profile"/>
              </div>
              <div class="">
                <button type="button" class="addValue" @click="addContact()" name="button">Validate the contact</button>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="vactions">
        <button class="addValue_invert" @click="close">
          Cancel
        </button>
        <button class="addValue" @click="save">
          Save
        </button>

      </div>
    </v-card>
  </v-dialog>
</template>

<script>


import { nextTick } from 'vue';
import { toast } from 'vue-sonner'
import Treeselect from 'vue3-treeselect'
import FileUploader from '@/components/FileUploaderPitchDeck.vue';

import { useVuelidate } from '@vuelidate/core'
import { required,maxLength,helpers,email,numeric,maxValue,minValue } from '@vuelidate/validators'
import { mapState } from 'vuex';

export default {
  props: {
    dialogVisible: Boolean,
    s : Object,
    dict: Object,
    what : String
  },
  components: {
    Treeselect,

    FileUploader
  },
  setup () {
   return { v$: useVuelidate() }
  },
  validations () {
   return {
     newcontact:{
       name:  {required :helpers.withMessage('Name is required.', required),},
       email: {
         required :helpers.withMessage('Email is required.', required),
         email : helpers.withMessage('Please provide a valid email address for contact.', email),
       },
        position: {required :helpers.withMessage('Position is required.', required),},
     },
     founder:{
       name:  {required :helpers.withMessage('Name is required.', required),},
      position: {required :helpers.withMessage('Position is required.', required),},
     },
     startup:{
       name: {
         required :helpers.withMessage('Organization name is required.', required),
       },
       TRL: {  /* eslint-disable */
         maxValue: helpers.withMessage(
             ({
               $pending,
               $invalid,
               $params,
               $model
             }) => `Max value is 9.`,
             maxValue(9)
           ),
           minValue: helpers.withMessage(
               ({
                 $pending,
                 $invalid,
                 $params,
                 $model
               }) => `Min value is 1.`,
               minValue(1)
             ),
             /* eslint-enable */
       },
       website: {
         required :helpers.withMessage('Please provide a website.', required),
       },
       company_founded_year:{
         required :helpers.withMessage("Please provide innovator's foundation year.", required),
         numeric: helpers.withMessage('Please provide a valid foundation year.', numeric),
       },
      location:{
        required :helpers.withMessage('Please provide where you are based.', required),
      },
      founders:{
        required :helpers.withMessage('Please tell us more about the founder(s).', required),
      },
      key_contact_name:{
        required :helpers.withMessage('Please provide a name for your key contact.', required),
      },
      key_contact_email:{
        required :helpers.withMessage('Please provide an email for your key contact.', required),
        email : helpers.withMessage('Please provide a valid email address for key contact.', email),
      },
      key_contact_phone:{
        required :helpers.withMessage('Please provide a phone number for your key contact.', required),
      },
      woman_cofounder: {
        required :helpers.withMessage('Please provide if you have a female co-founder or not.', required),
      },
      full_brand: {
        required :helpers.withMessage('Is your solution a branded consumer product?', required),
      },
      team_size:{
        required :helpers.withMessage('Please provide how many people work at the company.', required),
        numeric: helpers.withMessage('Please provide a valid team size.', numeric),
      },
      value_proposition:{
        required :helpers.withMessage('Please pitch your company.', required),
              /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please pitch your company in less than ${$params.max} characters.`,
            maxLength(700)
          )
                /* eslint-enable */
      },
      solution:{
        required :helpers.withMessage('Please tell us more about your solution.', required),
              /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please describe your solution in less than ${$params.max} characters.`,
            maxLength(700)
          )
                /* eslint-enable */
      },
      product_category:{
        required :helpers.withMessage('Innovation category is required.', required),
        /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please select up to ${$params.max} innovation categories.`,
            maxLength(5)
          )
          /* eslint-enable */
      },
      innovation_area:{
        required :helpers.withMessage('Innovation area is required.', required),
        /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please select up to ${$params.max} innovation areas.`,
            maxLength(5)
          )
          /* eslint-enable */
      },
      IP:{
        required :helpers.withMessage('Please provide what type of IP you have.', required),
      },
      company_type:{
        required :helpers.withMessage('Please provide the company type', required),
      },
      application_area:{
        required :helpers.withMessage('Please provide the main application domains of your solution.', required),
        /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please select up to ${$params.max} elements.`,
            maxLength(5)
          )
            /* eslint-enable */
      },
      key_benefits:{
         required :helpers.withMessage('Please provide the benefits of your solution for consumers or customer.', required),
      },
      development_stage:{
        required :helpers.withMessage("Please provide  your innovation's development stage.", required),
      },
      funding_stage:{
         required :helpers.withMessage('Please provide your funding stage.', required),
      },
      markets:{
         required :helpers.withMessage('Please provide where your solution is currently deployed.', required),
      },
      revenue: {
        value: {
           numeric  :helpers.withMessage('Please provide a valid revenue value.', numeric),
         },
        unit: {
          required :helpers.withMessage('Revenue unit is required.', required),
         },
        currency: {
          required  :helpers.withMessage('Revenue currency is required.', required),
        }
      },
      business_model:{
         required :helpers.withMessage('Please provide your business model.', required),
      },
      paying_customers:{
        required :helpers.withMessage('Please provide if you have paying customers or not.', required),

      },
      main_clients:{
        required :helpers.withMessage('Please tell us about your reference customers.', required),

      }

     }

   }
 },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      bindProps: {
        mode: "international",
        defaultCountry: "FR",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        preferredCountries: ["FR", "CH","US",'ES',"IT","GB",'NL'],
        wrapperClasses: "",
      },
      startup: {
        market_potential:{
          value:null,
          currency: null,
          unit:null,
        },
        investment_raised:{
          value:null,
          currency: null,
          unit:null,
        },
        revenue:{
          value:null,
          currency: "EUR",
          unit:"M",
        },
        last_funding_round:{
          value:null,
          currency: null,
          unit:null,
        }
      },
      uploadProceedBanner: false,
      uploadProceedLogo:false,
      founder:{
        name: "",
        position:"",
        linkedin_profile:""
      },
      contactus:{
        name:"",
        email:"",
        company_name:"",
        topic :null,
        message : "",
      },
      newcontact:{
        name: "",
        position:"",
        email:"",
        phone:"",
        linkedin_profile:""
      },
      file: null,
      chunks: [],
      chunksLogo: [],
      uploaded: 0,
      uploadProceed: false,
      addedFile: null,
      step : 1,
      data_policy:false,
      dialog_image: false,
      logo : null,
    }

  },
  methods:{

    next_step(){
      this.step++;
      nextTick(() => {
          document.getElementById("stepperScrollCard").scrollIntoView({behavior: "instant", block: "start", inline: "nearest"})
        });
    },
    prev_step(){
      this.step--;
      nextTick(() => {
          document.getElementById("stepperScrollCard").scrollIntoView({behavior: "instant", block: "start", inline: "nearest"})
        });
    },
    imageChange(val){
      if(val){
        this.startup.image = val;
      }
    },
    logoChange(val){
      if(val){
        this.startup.logo = val;
      }
    },
    deleteFile(docid){
        this.axios.post(process.env.VUE_APP_API_URL+"/delete_pitchdeck",{
            startup : this.startup._id.$oid,
            docid : docid,
        },{
          headers: {
              'Content-Type': 'application/json',
          }
      }).then( (r) => {
        console.log(r);
        this.startup.presentation_deck_file = null;
        toast.success("File successfully deleted");

      }).catch( () => {
             toast.error("There is an error while deleting the file!")
      });
    },

    resize(ta) {
        let element = this.$refs[ta];
        if(element){
          element.style.height = "60px";
          element.style.height = (element.scrollHeight + 30) + "px";
        }

    },
    save(){
      var isOk = true;
      if(this.startup.no_revenue_yet == true){
        this.startup.revenue.value = 0;
        this.startup.revenue.unit ="M";
      }
      //only validate form if startup is not partial
      //while partial we not validate on save to allow completing the profile in multiple times
      // but when submited, modifications have to keep datas valid
      if(this.role == 'Admin'){
        isOk = true;
      }
      else{
        if(!this.startup.partial){
        if(this.what == "summary"){
          this.v$.startup.application_area.$touch();
          this.v$.startup.company_type.$touch();
          this.v$.startup.solution.$touch();
          this.v$.startup.value_proposition.$touch();
          this.v$.startup.revenue.$touch();
          this.v$.startup.location.$touch();
          if (this.v$.startup.company_type.$invalid ||this.v$.startup.application_area.$invalid || this.v$.startup.solution.$invalid || this.v$.startup.value_proposition.$invalid || this.v$.startup.revenue.$invalid || this.v$.startup.location.$invalid ) {
            toast.error("Please correct your entries");
            isOk = false;
          }
        }
          if(this.what == "contact"){
            this.v$.startup.name.$touch();
            this.v$.startup.key_contact_name.$touch();
            this.v$.startup.key_contact_email.$touch();
            this.v$.startup.key_contact_phone.$touch();
            this.v$.startup.website.$touch();
            if (this.v$.startup.name.$invalid || this.v$.startup.key_contact_name.$invalid || this.v$.startup.key_contact_email.$invalid || this.v$.startup.key_contact_phone.$invalid || this.v$.startup.website.$invalid ) {
              toast.error("Please correct your entries");
              isOk = false;
            }
          }
          if(this.what == "contacts"){
            this.v$.startup.key_contact_name.$touch();
            this.v$.startup.key_contact_email.$touch();
            this.v$.startup.key_contact_phone.$touch();
            if (this.v$.startup.key_contact_name.$invalid || this.v$.startup.key_contact_email.$invalid || this.v$.startup.key_contact_phone.$invalid ) {
              toast.error("Please correct your entries");
              isOk = false;
            }
          }

          if(this.what == "company"){

            this.v$.startup.name.$touch();
            this.v$.startup.location.$touch();
            this.v$.startup.website.$touch();
            this.v$.startup.funding_stage.$touch();
                  console.log(this.startup.founders);console.log(  this.v$.startup.founder);
            this.v$.startup.founders.$touch();
            this.v$.startup.company_founded_year.$touch();
            if(this.v$.startup.founders.$invalid || this.v$.startup.funding_stage.$invalid || this.v$.startup.name.$invalid || this.v$.startup.location.$invalid || this.v$.startup.website.$invalid || this.v$.startup.company_founded_year.$invalid){
              toast.error("Please correct your entries");
              isOk = false;
            }
          }

          if(this.what == "traction"){
            this.v$.startup.development_stage.$touch();
            this.v$.startup.markets.$touch();
            this.v$.startup.revenue.$touch();
            this.v$.startup.paying_customers.$touch();
            this.v$.startup.main_clients.$touch();
            this.v$.startup.business_model.$touch();

            if( this.v$.startup.development_stage.$invalid ||
                this.v$.startup.markets.$invalid ||
                this.v$.startup.revenue.$invalid ||
                this.v$.startup.paying_customers.$invalid ||
                this.v$.startup.main_clients.$invalid ||
                this.v$.startup.business_model.$invalid
              ){
              toast.error("Please correct your entries");
              isOk = false;
            }
          }


          if(this.what == "capabilities"){
            this.v$.startup.IP.$touch();
            this.v$.startup.woman_cofounder.$touch();
            this.v$.startup.team_size.$touch();
            if(this.v$.startup.IP.$invalid || this.v$.startup.woman_cofounder.$invalid || this.v$.startup.team_size.$invalid){
              toast.error("Please correct your entries");
              isOk = false;
            }
          }

          if(this.what == "solution"){
            this.v$.startup.product_category.$touch();
            this.v$.startup.innovation_area.$touch();
            this.v$.startup.value_proposition.$touch();
            this.v$.startup.solution.$touch();
            this.v$.startup.key_benefits.$touch();
                this.v$.startup.full_brand.$touch();
                      this.v$.startup.TRL.$touch();
            if(this.v$.startup.product_category.$invalid ||
            this.v$.startup.innovation_area.$invalid ||
            this.v$.startup.value_proposition.$invalid  ||
            this.v$.startup.solution.$invalid ||
            this.v$.startup.full_brand.$invalid ||
            this.v$.startup.TRL.$invalid ||
            this.v$.startup.key_benefits.$invalid){
              toast.error("Please correct your entries");
              isOk = false;
            }
          }

          //validator depends of the displayed form
        }
      }
      console.log("ISOK ",isOk);
      if(isOk){
        if(this.startup.name == ""){
          toast.error("Please correct your entries");
        }

        else{
          if(this.startup.website){
            this.startup.website = this.startup.website.toLowerCase();
          }
          this.axios.post(process.env.VUE_APP_API_URL+"/public_startup_save/"+this.startup._id.$oid,
            this.startup,
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r);
            this.$emit('confirmed',this.startup)
            toast.success("Your data has been saved");
          }).catch( (e) => {
            console.log(e);
          toast.error("Sorry an error occurs !")
          });
        }
      }


    },
    addFounder(){
      var isOk = true;
      this.v$.founder.name.$touch();
      this.v$.founder.position.$touch();
      if (this.v$.founder.name.$invalid || this.v$.founder.position.$invalid ) {
        toast.error("Please correct your entries");
        isOk = false;
      }
      if(isOk){
        this.axios.post(process.env.VUE_APP_API_URL+"/startup_add_founder",
          {
              startup: this.startup._id.$oid,
              founder: this.founder
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          if(!this.startup.founders)this.startup.founders = [];
          this.startup.founders.push(r.data);
          this.founder.name = "";
          this.founder.position = "";
          this.founder.email = "";
          this.founder.linkedin_profile = "";
          this.$nextTick(() => { this.v$.$reset() })
        }).catch( (e) => {
          console.log(e);
        toast.error("Sorry an error occurs !")
        });
      }

    },
    isThereFounders(f){
      if(f == null){
        return false;
      }
      else if(f.length > 0){
        return true;
      }
      else{
        return false;
      }
    },
    founderLink: function(link){
      if(link){
        if(link.startsWith("https://")){
          return link;
        }
        else{
          return "https://"+link;
        }
      }
      else{
        return null;
      }

    },
    close(){
        this.$emit('close',false)
    },
    removeFounder(founder,i){
      console.log(i);
      this.axios.post(process.env.VUE_APP_API_URL+"/startup_remove_founder",  {
              startup: this.startup._id.$oid,
              founder: founder
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
      }).then( (r) => {
        console.log(r);
          this.startup.founders.splice(i, 1);
      }).catch( (e) => {
          console.log(e);
      });

    },
    toLowercase(event) {
                       event.target.value = event.target.value.toLowerCase();
                       this.startup.website = event.target.value;
                   },
    addContact(){
      var isOk = true;
      this.v$.newcontact.name.$touch();
      this.v$.newcontact.email.$touch();
      this.v$.newcontact.position.$touch();
      if (this.v$.newcontact.name.$invalid || this.v$.newcontact.email.$invalid || this.v$.newcontact.position.$invalid ) {
        toast.error("Please correct your entries");
        isOk = false;
      }
      if(isOk){
        this.axios.post(process.env.VUE_APP_API_URL+"/startup_add_contact",
          {
              startup: this.startup._id.$oid,
              contact: this.newcontact
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          if(!this.startup.contacts)this.startup.contacts = [];
          this.startup.contacts.push(r.data);
          this.newcontact.name = "";
          this.newcontact.phone ="";
          this.newcontact.email ="";
          this.newcontact.position = "";
          this.newcontact.linkedin_profile = "";
          this.$nextTick(() => { this.v$.$reset() })
        }).catch( (e) => {
          console.log(e);
        toast.error("Sorry an error occurs !")
        });
      }

    },
    removeContact(founder,i){
      console.log(i);
      this.axios.post(process.env.VUE_APP_API_URL+"/startup_remove_contact",  {
              startup: this.startup._id.$oid,
              founder: founder
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
      }).then( (r) => {
        console.log(r);
          this.startup.contacts.splice(i, 1);
      }).catch( (e) => {
          console.log(e);
      });

    },
    sendMsg(){
      var errorContactus = false;
      if(this.contactus.name == ""){
        errorContactus = true;
      }
      if(this.contactus.email == ""){
        errorContactus = true;
      }
      if(this.contactus.company_name == ""){
        errorContactus = true;
      }
      if(this.contactus.topic == null){
        errorContactus = true;
      }
      if(this.contactus.message == ""){
        errorContactus = true;
      }
      if(errorContactus == true){
         toast.error("Please correct your entries");
      }
      else{
        //SEND MESSAGE
        this.axios.post(process.env.VUE_APP_API_URL+"/send_help_msg",
          this.contactus,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);

            toast.success("Message sent",{description:"We’ll respond to you shortly."});
          this.close();
        });
      }
    },
    fileIsUpload(e){
      console.log(e);
      if(e){
        this.startup.presentation_deck_file = e;
      }
    },

    selectBanner(event) {
      this.uploaded = 0;
        this.file = event.target.files.item(0);
        this.createChunks();
        this.uploadProceedBanner = true;
        // console.log(this.chunks);
        // this.upload();
    },
    selectLogo(event) {
      this.uploaded = 0;
        this.file = event.target.files.item(0);
        this.createChunksLogo();
        this.uploadProceedLogo = true;
        // console.log(this.chunks);
        // this.upload();
    },
    upload() {
        this.axios(this.config).then((r) => {
          console.log(r);
          this.chunks.shift();
          if(r.data)if(r.data)this.addedFile = r.data;
        }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
    },
    uploadLogo() {
        this.axios(this.configLogo).then((r) => {
          console.log(r);
          this.chunksLogo.shift();
          if(r.data)if(r.data)this.addedFile = r.data;
        }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
    },
    createChunks() {
        let size = 8192, chunks = Math.ceil(this.file.size / size);

        for (let i = 0; i < chunks; i++) {
            this.chunks.push(this.file.slice(
                i * size, Math.min(i * size + size, this.file.size), this.file.type
            ));
        }
    },
    createChunksLogo() {
        let size = 8192, chunks = Math.ceil(this.file.size / size);

        for (let i = 0; i < chunks; i++) {
            this.chunksLogo.push(this.file.slice(
                i * size, Math.min(i * size + size, this.file.size), this.file.type
            ));
        }
    }
  },
  computed: {
    ...mapState(['role']),
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                       this.$emit('close',false)
             }
      }
    },
    startup_image: function(){
      if(this.startup.image){
        console.log(this.startup.image);
        return this.startup.image.$oid;
      }
      else{
        return null;
      }

    },

    startup_logo: function(){
      if(this.startup.logo){
        console.log(this.startup.logo);
        return this.startup.logo.$oid;
      }
      else{
        return null;
      }

    },

    progress() {
      if(this.file){
          return Math.floor((this.uploaded * 100) / this.file.size);
      }
      else{return 0;}

    },
    formData() {
        let formData = new FormData;

        formData.set('imageTargetDBField', 'banner');
        formData.set('is_last', this.chunks.length === 1);
        formData.set('file', this.chunks[0], `${this.file.name}.part`);
        formData.set('file_extension_original', this.file.name.split('.').pop());
        formData.set('startup', this.startup._id.$oid);
        formData.set('fileType', "banner");
        return formData;
    },
    formDataLogo() {
        let formData = new FormData;

        formData.set('imageTargetDBField', "logo");
        formData.set('is_last', this.chunksLogo.length === 1);
        formData.set('file', this.chunksLogo[0], `${this.file.name}.part`);
        formData.set('file_extension_original', this.file.name.split('.').pop());
        formData.set('startup', this.startup._id.$oid);
        formData.set('fileType', "logo");
        return formData;
    },
    config() {
        return {
            method: 'POST',
            data: this.formData,
            url: this.apiUrl+'/upload_public_image',
          //  url: this.apiUrl+'/restrict/test_upload_startup/649c14ec4df341c71a0a5d03',

            headers: {
                'Content-Type': 'application/octet-stream'
            },
            onUploadProgress: event => {
                this.uploaded += event.loaded;
            }
        };
    },
    configLogo() {
        return {
            method: 'POST',
            data: this.formDataLogo,
            url: this.apiUrl+'/upload_public_image',
          //  url: this.apiUrl+'/restrict/test_upload_startup/649c14ec4df341c71a0a5d03',

            headers: {
                'Content-Type': 'application/octet-stream'
            },
            onUploadProgress: event => {
                this.uploaded += event.loaded;
            }
        };
    }
  },
  watch: {
    dialogVisible: function(){
      this.startup = this.s;
      this.step = 1;
      nextTick(() => {
        this.resize('value_proposition');
        this.resize('solution');
      });
    },

    chunksLogo: {
      handler(val) {
        if (val.length > 0) {
               this.uploadLogo();
        }
        else{
          this.uploadProceedLogo = false;
          this.logoChange(this.addedFile);

        }
      },
      deep: true
    },

    chunks: {
      handler(val) {
        if (val.length > 0) {
               this.upload();
        }
        else{
          this.uploadProceedBanner = false;
          this.imageChange(this.addedFile);

        }
      },
      deep: true
    },
  }


}
</script>

<style media="screen" scoped>
.v-card{
  padding:0px;
  border-radius:20px !important;
}

.v-card-title{
  background: #EFEFEF;
  padding: 20px;
  /* text-transform: uppercase; */
  color: #000;
  position: sticky;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  font-weight:700;
  color: #000 !important;
}
.v-card-content{
  padding:20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.fieldTitle{
  font-weight:600;
  margin-bottom:10px;
  display:block;
  color:#000;
}
.oneField{
  /* margin-top:20px; */
  display:block;
}

.info_startup_2{
  display: flex;
  gap: 10px;
    margin-bottom:14px;
    flex-direction: column;
    position:relative;
}


.info_startup_2.flexh{
  flex-direction: row;
}
.info_startup_2 .info_value{
  font-size:16px;
  line-height: 22px;
  width: 100%;
  resize-x:none;
}
.info_value{
white-space: pre-wrap
}


.info_value_investment{
  width:auto !important;
  display:inline-block;
  max-width: 100px;
}

.selectDevise{
  border:1px solid #ccc;
  border-radius:10px;
  -webkit-appearance: auto;
  -moz-appearance :auto;
  padding:10px;
  max-width: 100px;

}
input,textarea{
border: 1px solid #ccc;
border-radius:10px;
  padding:10px;
  width:100%;

}

.w100{
  width:100%;
}

.v-input__details {
  align-items: flex-end;
  display: flex;
  font-size: 0.75rem;
  font-weight: 400;
  grid-area: messages;
  letter-spacing: 0.0333333333em;
  line-height: normal;
  min-height: 0;
  padding-top: 6px;
  overflow: hidden;
  justify-content: space-between;
}

.vactions{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap:10px;
    padding:20px;
}
.vactions.left_actions{
  align-items: flex-end;
  justify-content: flex-end;
}
.vactions.right_actions{
  align-items: flex-start;
  justify-content: flex-start;
}

.vactions.right_actions .flexRight{
  margin-left: auto;
}

.addValueModal button.addValue{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  background:#3783C5;
  margin: 5px;

  color:#FFF;
}

.addValueModal button.addValue_invert{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  color:#3783C5;
  margin: 5px;

}

.addValueModal button.addValue_invert:disabled{
opacity:.5;
background:#EFEFEF;

}

.withStepper{
  display:flex;
  gap:10px;
}
.withStepper .stepper{
  margin-left:auto;
  color:#000 !important;
}
input:focus,
input:focus-visible{
  border:1px solid #ccc !important;
   outline: none;
   box-shadow: none !important;
}


.subfields{
  display: flex;
  flex-direction: column;
  gap: 15px;
  width:100%;
}

.fieldSubTitle {
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
  font-size:.8rem;
  color: #555;
}

.trashFounder{
  margin-left:10px;
}
.mb0{
  margin-bottom: 0px;
}

.presentationDeck{
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.oneHalf{
  flex:1;
}
@media screen and (max-width:890px){
  .presentationDeck{
    flex-direction: column;
  }
}
.table_brief_doc thead td{
  background: #EEE;
  padding-top:5px;
  padding-bottom:5px;
}
.table_brief_doc tbody{
  border:1px solid #EEE;
}
.table_brief_doc a{
  color: inherit;
}
.tblue{
    color: #3783C5
}

.explaination{
  font-size:.8rem;
  margin-top:10px;
  display:block;
  width:100%;
  color:#333;
}


.startup_banner{

  position:relative;
  height:300px;
  padding: 0 !important;
}
.startup_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.startup_banner .fallbackBanner{
  width: 100%;
  height: 100%;
  background:#EFEFEF;
}

.changeImage{
  position:absolute;
  top:15px;
  right:30px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}

.uploadProceedBanner{
  position: absolute;
    top: 0;
    left: 0;
    transform: none;
    background: rgba(255,255,255,0.9);
    padding: 20px;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-content: center;
}
.uploadProceedBanner .uploadProcess{
  width:80%;
}

#bannerUp{
  display: none;
}

#logoUp{
  display: none;
}

.startup_logo{
  width: 300px;
    height: 150px;
    position:relative;
}
.startup_logo img{
  width: 300px;
    height: 150px;
    object-fit: contain;
    padding:10px;
}

.startup_logo .fallbackLogo{
  width:300px;
  height:150px;
  background:#fff;
}


.changeImageLogo{
  position:absolute;
  top:0px;
  right:0px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}

.info_startup_2.dblock{
  display:block;
}
.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.ml5{
  margin-left: 5px;
}

@media screen and (max-width:890px){
  .listOfContacts tr{
    display:flex;
    flex-direction: column;
  }
  .listOfContacts .text-right{
    text-align: left !important;
        float: left;
        border-bottom: 1px solid #ccc;
  }
}

.picto_link_linkedin{
    color:#3783C5;
}

.lengthIndicator{
  text-align: right;
  font-size: 11px;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: 10px;
  right: 20px;

}

.required{
  font-size: 20px;
  top: 0;
  color: red;

}
.fallbackBanner_size{
  font-size: 40px;
  color: #CCC;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.tred{
  color:#B00020;
}
.editStartupModal .alert-warning{
  padding:5px 10px;
}

.realRevenueInput{
  margin-top:20px;
}
.selectIt label{
font-size:15px;
font-weight: 600;
color:rgba(4, 36, 106, 1);
display:flex;
align-items: center;
gap: 5px;

}
.selectIt input{
  width:14px;
  height:14px;
}
</style>

<style media="screen">
.editStartupModal .v-input__control{
border: 1px solid #ccc;
  border-radius: 10px;
  background:#FFF;
}

.editStartupModal .v-field__overlay{
  display:none;
}

.editStartupModal .vue-treeselect__control {
  border: 1px solid #ccc;
  border-radius:10px;
    padding:10px;
    width:100%;
}

.editStartupModal  .vue-treeselect__placeholder, .editStartupModal  .vue-treeselect__single-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 5px;
  padding-right: 5px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  line-height: 22px;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
  font-size: 18px;
}
.editStartupModal .v-field--variant-filled .v-field__outline::before,
.editStartupModal  .v-field--variant-underlined .v-field__outline::before {
  display:none;
}

.editStartupModal .vti__input{
  padding:10px;
  box-shadow: none !important;
}

.editStartupModal .vue-tel-input{
  border: 1px solid #ccc;
  box-shadow: none;
  border-radius: 10px;
}
.editStartupModal .vti__dropdown{
  background:transparent !important;
}
.editStartupModal .v-input__details{
  display:none;
}
.editStartupModal .v-field__field{
  max-width:90%;
}
</style>
